import { useState } from 'react'

import {
  $albumCollectionsTableSearchInputValue,
  albumCollectionsTableSearchChanged,
} from '@/entities/album-collections'
import {
  $albumsTableSearchInputValue,
  AlbumsTableFiltersMenu,
  albumsTableSearchChanged,
} from '@/entities/albums'
import { STRINGS } from '@/shared/config'
import { useHashTabs } from '@/shared/lib/react-hooks'
import { BorderlessTabs, HeaderContent } from '@/shared/ui'
import { ContentWrapper } from '@/shared/ui'
import { PrimaryButton } from '@/shared/ui'
import { FilterOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Input, Layout, Popover, Space } from 'antd'
import { useUnit } from 'effector-react'

import {
  type CollectionsListPageTabsKeys,
  CollectionsListPageTabsKeysArray,
  CollectionsListPageTabsKeysEnum,
} from './lib/tabs'
import {
  $collectionsListPageTab,
  CollectionsListPageGate,
  collectionsListPageTabChanged,
} from './model/collections-list.model'
import { CollectionTypeChoiceModal } from './ui/CollectionTypeChoiceModal'
import { AlbumCollectionsTab, AlbumsTab } from './ui/tabs'

export function CollectionsListPage() {
  const albumsSearch = useUnit($albumsTableSearchInputValue)
  const albumCollectionsSearch = useUnit($albumCollectionsTableSearchInputValue)
  const changeAlbumsSearch = useUnit(albumsTableSearchChanged)
  const changeAlbumCollectionsSearch = useUnit(
    albumCollectionsTableSearchChanged,
  )

  const [modalOpen, setModalOpen] = useState(false)

  const { tab, handleTabChange } = useHashTabs<CollectionsListPageTabsKeys>(
    CollectionsListPageTabsKeysArray,
    $collectionsListPageTab,
    collectionsListPageTabChanged,
  )

  return (
    <Layout>
      <CollectionsListPageGate />
      <CollectionTypeChoiceModal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
      />
      <HeaderContent
        title="Коллекции"
        description="Здесь можно посмотреть каталог альбомов и выпусков, управлять ими, а также видеть, создавать, обновлять и удалять контент"
        buttonSlot={
          // Вызов модалки
          <PrimaryButton
            onClick={() => setModalOpen(true)}
            icon={<PlusOutlined />}
          >
            Создать
          </PrimaryButton>
        }
      />
      <ContentWrapper verticalPadding="small">
        <BorderlessTabs
          activeKey={tab}
          onChange={handleTabChange}
          destroyOnHidden
          tabBarExtraContent={
            <Space>
              <Popover
                content={<AlbumsTableFiltersMenu />}
                title={STRINGS.label_filters_control}
                trigger="click"
                placement="bottom"
                destroyOnHidden
              >
                <Button disabled={tab !== 'album'} icon={<FilterOutlined />}>
                  {STRINGS.label_filters_control}
                </Button>
              </Popover>

              <Input
                placeholder={STRINGS.placeholder_search_by_name_input}
                allowClear
                addonAfter={<SearchOutlined />}
                value={
                  (tab === 'album' ? albumsSearch : albumCollectionsSearch) ||
                  ''
                }
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const searchString = event.target.value
                  if (tab === 'album') changeAlbumsSearch(searchString)
                  else changeAlbumCollectionsSearch(searchString)
                }}
              />
            </Space>
          }
          items={[
            {
              label: 'Альбомы',
              key: CollectionsListPageTabsKeysEnum.album,
              children: <AlbumsTab />,
            },
            {
              label: 'Выпуски',
              key: CollectionsListPageTabsKeysEnum.albumcollection,
              children: <AlbumCollectionsTab />,
            },
          ]}
        />
      </ContentWrapper>
    </Layout>
  )
}
